import { ApprovalRequiredAlert } from '@/components/reserve/Reserve/views/ApprovalRequiredAlert';
import { UserHealthRestrictedAlert } from '@/components/reserve/Reserve/views/UserHealthRestrictedAlert';
import React from 'react';
import { ReserveProps } from '@/components/reserve/Reserve/types';
import { ReserveFormContext } from '@/components/reserve/Reserve/ReserveFormProvider';
import { ReserveFormDates } from '@/components/reserve/Reserve/controls/ReserveFormDates';
import { ReserveFormStartTime } from '@/components/reserve/Reserve/controls/ReserveFormStartTime';
import { ReserveFormDuration } from '@/components/reserve/Reserve/controls/ReserveFormDuration';
import { ReserveFormResources } from '@/components/reserve/Reserve/controls/ReserveFormResources';
import { ReserveFormRestrictionAlerts } from '@/components/reserve/Reserve/views/ReserveFormRestrictionAlerts';
import { ReserveFormRecurring } from '@/components/reserve/Reserve/views/ReserveFormRecurring';
import { ReserveFormMeetingRoomNotes } from '@/components/reserve/Reserve/views/ReserveFormMeetingRoomNotes';
import { ReserveFormParking } from '@/components/reserve/Reserve/views/ReserveFormParking';
import { ReserveFormErrors } from '@/components/reserve/Reserve/views/ReserveFormErrors';
import { ReserveFormFloor } from '@/components/reserve/Reserve/views/ReserveFormFloor';
import { ReserveFormTimeZoneMismatchAlert } from '@/components/reserve/Reserve/views/ReserveFormTimeZoneMismatchAlert';
import { ReserveFormActions } from '@/components/reserve/Reserve/views/ReserveFormActions';
import { ReserveFormForm } from '@/components/reserve/Reserve/ReserveFormForm';
import { ReserveFormWeekDays } from '@/components/reserve/Reserve/views/ReserveFormWeekDays';
import { ReserveFormOtherUserReservation } from '@/components/reserve/Reserve/views/ReserveFormOtherUserReservation';
import { ReserveFormMeetingRoomUsers } from '@/components/reserve/Reserve/views/ReserveFormMeetingRoomUsers';
import { ReserveFormMeetingRoomTitle } from '@/components/reserve/Reserve/views/ReserveFormMeetingRoomTitle';
import { ReserveFormOnlineMeeting } from '@/components/reserve/Reserve/controls/ReserveFormOnlineMeeting';

export const Reserve: React.FC<ReserveProps> = ({
  onClose,
  showActions = true,
  isCompact = false
}) => {
  return (
    <>
      {onClose ? <ReserveFormTimeZoneMismatchAlert onClose={onClose} /> : null}
      <ReserveFormRestrictionAlerts />
      <UserHealthRestrictedAlert className="mb-2 max-w-xl" />
      <ApprovalRequiredAlert className="mb-2 max-w-xl" />
      <ReserveFormContext.Consumer>
        {(state) => {
          if (!state) return null;
          const { form, reservationDurationLabel, submitReservation } = state;
          return (
            <ReserveFormForm onSubmit={form.handleSubmit(submitReservation)}>
              <div className="flex flex-col gap-2">
                <ReserveFormOtherUserReservation />
                <ReserveFormMeetingRoomTitle />
                <div className="grid grid-cols-3 gap-3">
                  <ReserveFormDates />
                  <div className="">
                    <ReserveFormStartTime />
                  </div>
                  <div className="text-left">
                    <ReserveFormDuration />
                  </div>
                </div>
                <div className={''}>
                  Reservation duration: {reservationDurationLabel}
                </div>

                <ReserveFormOnlineMeeting isEdit={false} />
                <ReserveFormWeekDays />
                <ReserveFormRecurring isCompact={isCompact} />
                <ReserveFormMeetingRoomUsers />
                <ReserveFormFloor />
                <div className="relative mt-1 text-left">
                  <ReserveFormResources />
                </div>
                <ReserveFormParking />
                <ReserveFormMeetingRoomNotes />
                <ReserveFormErrors />
                {showActions && <ReserveFormActions />}
              </div>
            </ReserveFormForm>
          );
        }}
      </ReserveFormContext.Consumer>
    </>
  );
};
